import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const wholeTokenFromCookie = JSON.parse(getCookieByName(sharedCookieKey));

        let spatFromCookie = wholeTokenFromCookie.spat;

        let a = payload.ticket1_1_1 || '';
        let b = payload.ticket1_1_2 || '';
        let c = payload.ticket1_1_3 || '';
        let d = payload.ticket1_1_4 || '';
        let e = payload.ticket1_1_5 || '';

        payload.ticket_number = a + b + c + d + e;

        let checkResult = await apiClient(config).apiMethod({
            method: 'CTLEnterTicket',
            headers: {
                'X-Auth-Token': jwtFromCookie,
                'X-Auth-Spat': spatFromCookie,
            },
            args: {
                ...payload,
            },
        });

        const processCheckResult = (checkResult) => {
            if (!checkResult) {
                return {
                    success: false,
                    message: '_UNKNOWN',
                };
            }

            if (checkResult.code) {
                if (checkResult.code === '_SUCCESS') {
                    return {
                        entry: checkResult,
                        success: true,
                        message: 'success',
                    };
                }
                return {
                    success: false,
                    message: checkResult.code,
                    details: checkResult.message,
                };
            }

            return {
                entry: checkResult,
                success: true,
                message: 'success',
            };
        };

        return processCheckResult(checkResult);
    };
};
